import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectEstimationTarget, selectIsNewbuilding } from '../../selectors';

import { EMyHomeEstimationTargets } from '../../types/estimationTarget';

import { FlatComponent } from '../../components/FlatComponent';
import { HouseComponent } from '../../components/HouseComponent';
import { LandComponent } from '../../components/LandComponent';
import { NewbuildingComponent } from '../../components/NewbuildingComponent';

import { IMyHomeLayoutProps } from '../../types/myHomeForm';

const LAYOUT_MAP = {
  [EMyHomeEstimationTargets.flat]: FlatComponent,
  [EMyHomeEstimationTargets.house]: HouseComponent,
  [EMyHomeEstimationTargets.land]: LandComponent,
};

export const Layout: React.FC<IMyHomeLayoutProps> = props => {
  const estimationTarget = useSelector(selectEstimationTarget);
  const isNewbuilding = useSelector(selectIsNewbuilding);

  const MyHomeComponent = LAYOUT_MAP[estimationTarget];

  if (isNewbuilding) {
    return <NewbuildingComponent {...props} />;
  }

  return <MyHomeComponent {...props} />;
};
